/* eslint-disable react/prop-types */
import { useState, useEffect, useContext } from 'react';
import { Table } from 'ypf-pas-general-ui-components';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import NotFoundData from '../../NotFoundData/NotFoundData';
import { formatDate } from '../../../utils/formatUtils';
import { getAllTemplatesRequest } from '../../../services/templateServiceRequest';
import LoaderContext from '../../../context/LoaderProvider';
import useToast from '../../../hooks/useToast';

import './TemplateRequest.scss';

const TemplateRequest = ({
  checkBoxState,
  itemCheck,
  setCheckBoxState,
  setItemCheck,
  newFetch,
  goForceReset,
  templateNameToSearch,
  isPublic,
  viewWithOutCheckBox,
  previusPath
}) => {
  const [dataTemplate, setDataTemplate] = useState([]);
  const [paginationState] = useState({
    pageIndex: 0,
    pageSize: 5,
    sortBy: []
  });
  const [totalPages, setTotalPages] = useState(1);

  const { setLoader, loader } = useContext(LoaderContext);
  const { setNewToast } = useToast();

  const history = useHistory();

  const isDraft = history?.location?.pathname.includes('/edit/');
  const isCreateRequestService = history?.location?.pathname.includes('/createMultiple');

  const handleRedirectToVisualizeTemplate = ({ id, isOwn }) => {
    history.push({
      pathname: `/edit-template/request/${id}`,
      previusPath,
      onlyVisualizeRequestTemplate: true,
      isOwn
    });
  };

  const handleChangeSelect = (item) => {
    if (checkBoxState.includes(item)) {
      const newSelect = checkBoxState.filter((name) => name !== item);

      setCheckBoxState(newSelect);
      const newItem = itemCheck.filter(
        (itemTemplate) =>
          itemTemplate.nombrePlantilla !== dataTemplate[Number(item)].nombrePlantilla
      );

      setItemCheck(newItem);

      return;
    }

    setItemCheck([...itemCheck, dataTemplate[Number(item)]]);
    setCheckBoxState([...checkBoxState, item]);
  };

  const styleCell = ({ value }) => (
    <div
      className="row justify-content-center"
      style={{
        textAlign: 'center',
        display: 'flex'
      }}
    >
      {value}
    </div>
  );

  const columnsTable = [
    {
      Header: '',
      accessor: 'checkbox',
      hideSort: true,
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex',
            width: '.5px'
          }}
        >
          <input
            defaultChecked={checkBoxState.includes(row.id)}
            disabled={isDraft || isCreateRequestService ? false : !row?.original?.esPropia}
            onChange={() => handleChangeSelect(row.id)}
            type="checkbox"
            value={undefined}
          />
        </div>
      )
    },
    {
      Header: 'Nombre',
      accessor: 'nombrePlantilla',
      hideSort: true,
      Cell: ({ row }) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
          onClick={() => {
            handleRedirectToVisualizeTemplate({
              id: row?.original?.id,
              isOwn: row?.original?.esPropia
            });
          }}
          style={{
            textDecoration: 'none',
            color: '#0063bd'
          }}
        >
          {row?.original?.nombrePlantilla}
        </div>
      )
    },
    {
      Header: 'Tipo de evento',
      accessor: 'tipoEvento',
      hideSort: true,
      style: {
        fontWeight: '600',
        width: '350px'
      }
    },
    {
      Header: 'Servicios',
      accessor: 'servicios',
      hideSort: true,
      style: {
        width: '90px'
      },
      Cell: styleCell
    },
    {
      Header: 'Creadas el',
      accessor: 'fechaCreacion',
      hideSort: true,
      style: {
        width: '150px'
      },
      Cell: formatDate
    }
  ];

  const isPublicColumn = {
    Header: 'Es publica',
    accessor: 'isPublic',
    hideSort: true,
    style: {
      width: '150px'
    },
    Cell: styleCell
  };

  const creatorColumn = {
    Header: 'Creador',
    accessor: 'creator',
    hideSort: true,
    style: {
      width: '150px'
    },
    Cell: styleCell
  };

  // eslint-disable-next-line no-unused-vars
  const columnsAux2 = isPublic
    ? columnsTable.splice(columnsTable.length - 1, 0, creatorColumn)
    : columnsTable.splice(columnsTable.length - 1, 0, isPublicColumn);
  const columnsAux = [...columnsTable];
  // eslint-disable-next-line no-unused-vars
  const columnsWithOutCheckbox = columnsAux.splice(0, 1);

  const mapperRequestTemplates = (data) =>
    data?.map((item) => ({
      id: item.id,
      nombrePlantilla: item.nombre || item.nombrePlantilla,
      fechaCreacion: item.fechaCreacion,
      tipoEvento: item.tipoEvento,
      servicios: item.cantidadDeServicios || item.servicios,
      esPropia: item?.esPropia,
      isPublic: item?.esPublico ? 'Si' : 'No',
      creator: item?.usuarioCreador
    }));

  const fetchTemplatesRequest = async ({ pageIndex, pageSize }) => {
    setLoader(true);
    try {
      const requestTemplates = await getAllTemplatesRequest({
        skip: pageIndex + 1,
        pageSize: pageSize ?? 5,
        esPublica: isPublic,
        nombrePlantilla: templateNameToSearch
      });

      setTotalPages(requestTemplates?.totalPages);
      setDataTemplate(mapperRequestTemplates(requestTemplates?.items));
      setLoader(false);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
      setLoader(false);
    }
  };

  useEffect(() => {
    if (!viewWithOutCheckBox) {
      setItemCheck([]);
      setCheckBoxState([]);
      setLoader(true);
      fetchTemplatesRequest({
        pageIndex: 0
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFetch, viewWithOutCheckBox, isPublic]);

  useEffect(() => {
    if (viewWithOutCheckBox) {
      setDataTemplate([]);
      const mappedSelectItem = mapperRequestTemplates(itemCheck);

      setDataTemplate(mappedSelectItem);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewWithOutCheckBox]);

  return (
    <>
      {dataTemplate?.length > 0 && (
        <Table
          cantFiles={[5, 10, 20, 30]}
          columns={viewWithOutCheckBox ? columnsAux : columnsTable}
          data={dataTemplate}
          fetchData={fetchTemplatesRequest}
          goForceReset={goForceReset}
          initialState={{
            pageIndex: paginationState.pageIndex,
            pageSize: paginationState.pageSize,
            sortBy: paginationState.sortBy
          }}
          pageCount={totalPages}
          pagination={!viewWithOutCheckBox}
          titleLeft
          type="light"
        />
      )}
      {!dataTemplate?.length && !loader && (
        <div className="not-found-data-template">
          <NotFoundData />
        </div>
      )}
    </>
  );
};

TemplateRequest.propTypes = {
  checkBoxState: PropTypes.arrayOf(PropTypes.number),
  previusPath: PropTypes.string,
  itemCheck: PropTypes.arrayOf(
    PropTypes.shape({
      fechaCreacion: PropTypes.string,
      id: PropTypes.number,
      nombrePlantilla: PropTypes.string,
      servicios: PropTypes.number,
      tipoEvento: PropTypes.string
    })
  ),
  goForceReset: PropTypes.func,
  newFetch: PropTypes.bool.isRequired,
  setCheckBoxState: PropTypes.func,
  templateNameToSearch: PropTypes.string,
  setItemCheck: PropTypes.func,
  viewWithOutCheckBox: PropTypes.bool,
  isPublic: PropTypes.bool
};

TemplateRequest.defaultProps = {
  previusPath: '/manage-temp/request',
  checkBoxState: [],
  viewWithOutCheckBox: false,
  templateNameToSearch: '',
  isPublic: false,
  itemCheck: [],
  setCheckBoxState: () => {
    /* empty */
  },
  goForceReset: () => {
    /* empty */
  },
  setItemCheck: () => {
    /* empty */
  }
};

export default TemplateRequest;
